// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"b44063a8","787":"76826462"}[chunkId] + ".chunk.js";
};